import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, IconButton, Typography } from '@mui/material';

import { palette, spaces } from '../../../../../assets/styles/themes/tokens';
import createNonPropagatingEventHandler from '../../../../../utils/createNonPropagatingEventHandler';
import getMuiIcon from '../../../../../utils/getMuiIcon';

const MuiCardBaseShortMetadata: React.FC<{
  children: React.ReactNode;
  toggleTruncated: () => void;
  isTruncated: boolean;
}> = ({ children, toggleTruncated, isTruncated }) => {
  const { t } = useTranslation();

  return (
    <Box
      data-testid='mui-card-mobile__metadata-section'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'baseline',
      }}
    >
      <Typography
        variant='caption'
        color='secondary'
        sx={{ display: 'flex', gap: spaces.xs }}
      >
        {children}
      </Typography>
      {isTruncated && (
        <IconButton
          onClick={createNonPropagatingEventHandler(toggleTruncated)}
          sx={{
            position: 'absolute',
            bottom: `-${spaces.xs}`,
            right: `-${spaces.xs}`,
          }}
          aria-label={t('Show more')}
        >
          <Box
            component={getMuiIcon('arrowDown')}
            sx={{ color: palette.text.secondary }}
          />
        </IconButton>
      )}
    </Box>
  );
};

export default MuiCardBaseShortMetadata;
